<template>
	<div class="width-100 height-100 display-flex flex-column on-boarding-page-container" v-if="initialized">
		<div class="width-100 height-100 flex-centerize" v-if="showIntroLottie">
			<Lottie :height="350" :width="350" @complete="onAnimationEnd" :options="welcomeAnimation" />
		</div>
		<OnBoardingFlow v-else />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Lottie from '@/assets/lottie/lottie.vue';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { userOnBoardingMetadata } from '@/store/modules/auth/getters';
import OnBoardingFlow from '@/components/Onboarding/OnBoardingFlow/OnBoardingFlow.vue';
import WelcomeToPlyAnimation from '@/components/Onboarding/GuidedTutorials/assets/welcome-to-ply.json';
export default {
	name: 'OnBoarding',
	components: { Lottie, OnBoardingFlow },
	computed: {
		...mapGettersShorthand({ userOnBoardingMetadata }),
		welcomeAnimation() {
			return { animationData: WelcomeToPlyAnimation, loop: false };
		},
	},
	methods: {
		...mapActions(['saveUserMetadata']),
		async onAnimationEnd() {
			this.showIntroLottie = false;
			const newOnBoardingObj = { ...this.userOnBoardingMetadata, seenIntro: true };
			this.saveUserMetadata({ onBoarding: newOnBoardingObj });
		},
	},
	async created() {
		if (!this.userOnBoardingMetadata.seenIntro) {
			this.showIntroLottie = true;
		}
		this.initialized = true;
	},
	data() {
		return {
			initialized: false,
			showIntroLottie: false,
		};
	},
};
</script>

<style scoped lang="scss">
.on-boarding-page-container {
	background: #f9fafc;
}
</style>
